import React, {Component} from "react";
import {Form, InputNumber,Row,Input,Col,Table} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect';
import getSize from '../../../utils/getSize';
import NHFetch from '../../../utils/NHFetch';
import css from './index.css';
const now = new Date();
const year = now.getFullYear();

class CopyInitForm extends Component{
      constructor(props){
            super(props);
            this.state = {
                  copynd:undefined,
                  dataSource:[],
                  selectedRowKeys:[]
            }
      }
      componentDidMount(){
            this.getData();
      }
      onSelect = (value,label,option)=>{
            this.getData(value);
      }
      tableSelect = (selectedRowKeys, selectedRows)=>{
            let {setFieldsValue} = this.props.form;
            setFieldsValue({pkids:selectedRowKeys});
            this.setState({selectedRowKeys:selectedRowKeys});
      }
      getData = (copyNd)=>{
            let {setFieldsValue} = this.props.form;
            let params = {
                  sign:'zhxg_yxxt_lcgl_fzlc_queryPage',
                  searchParams:{nd:copyNd?copyNd:((year-1)+'')},
                  pagination:{page:0},
                  filters:{},
                  searchTextMap:{}
            }
            NHFetch("/proData/gridList","POST",params).then(res=>{
                  if(res){
                        let data = res.data.list;
                        let selectedRowKeys = [];
                        if(data && data.length>0){
                              for(let map of data){
                                    selectedRowKeys.push(map.PKID);
                              }
                        }
                        setFieldsValue({pkids:selectedRowKeys});
                        this.setState({dataSource:data,selectedRowKeys:selectedRowKeys});
                  }else{
                        this.setState({dataSource:[]});
                  }
            });
      }
      render(){
            const {form} = this.props;
            let rowSelection={
                  type:'checkbox',
                  selectedRowKeys: this.state.selectedRowKeys,
                  onChange: this.tableSelect
            }
            const columns = [
                  {
                        title: '序号',
                        width: '60px',
                        dataIndex: 'ROW_ID',
                        render:(text, record, index)=>{
                              return <span>{index+1}</span>
                        }
                  }, {
                        title: '生成流程名称',
                        width: '150px',
                        key:'sclcmc',
                        dataIndex: 'LCMC',
                        render:(text, record)=>{
                              return <div className={css.nomargin_nhformitem}>
                              <NHFormItem id={record.PKID} hasFeedback={true} form={form} required={true}
                                    initialValue={record.LCMC}>
                                    <Input/>
                              </NHFormItem> 
                              </div>
                        }
                  }, {
                        title: '原流程名称',
                        width: '150px',
                        key:'ylcmc',
                        dataIndex: 'LCMC'
                  }
            ];
            return <Form>
                  <Row>
                        <Col span={2} style={{lineHeight:'40px',textAlign:'right',paddingRight:'5px'}}><font color={'red'}>*</font>生成年度：</Col>
                        <Col span={10}>
                        <NHFormItem id={'scnd'} form={form} required={true}
                              initialValue={year}>
                              <NHSelect sign={'zhxg_year'}/>
                        </NHFormItem>
                        </Col>
                        <Col span={2} style={{lineHeight:'40px',textAlign:'right',paddingRight:'5px'}}><font color={'red'}>*</font>复制年度：</Col>
                        <Col span={10}>
                        <NHFormItem id={'copynd'} form={form} required={true}
                              initialValue={year-1}>
                              <NHSelect sign={'zhxg_year'} onSelect={this.onSelect}/>
                        </NHFormItem>
                        </Col>
                  </Row>
                  <div style={{display:'none'}}>
                        <NHFormItem id={'pkids'} form={form}>
                              <Input/>
                        </NHFormItem>
                  </div>
                  <Table size="small" dataSource={this.state.dataSource} columns={columns} pagination={false}
                        rowKey={record =>record.PKID} rowSelection={rowSelection} bordered={true}/>
            </Form>
      }
}
const CopyForm = Form.create()(CopyInitForm);

export default CopyForm;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/CopyForm.js